import React, {CSSProperties, MutableRefObject, useEffect, useRef, useState} from "react";
import {getCanvasDeviceRatio} from "../../../../utils/util-functions";
import "./SignatureCanvas.scss"
import {CONSTANTS} from "../../../../common/constants";

interface SignatureCanvasProps extends React.CanvasHTMLAttributes<HTMLCanvasElement> {
    getSignatureCanvasContext: (signatureCanvasContext: CanvasRenderingContext2D, signatureCanvas: HTMLCanvasElement) => void;
    isHighDPI?: boolean;
    canvasWidth: number;
}

export const SignatureCanvas: React.FunctionComponent<SignatureCanvasProps> = (props) => {
    const [signatureCanvasContext, setSignatureCanvasContext] = useState<CanvasRenderingContext2D>();
    const canvasRef = useRef<HTMLCanvasElement>() as MutableRefObject<HTMLCanvasElement>;
    const [canvas, setCanvas] = useState<HTMLCanvasElement>();
    const [realCanvasWidth, setRealCanvasWidth] = useState<number>(props.canvasWidth);
    const [canvasHeight, setCanvasHeight] = useState<number>(CONSTANTS.SIGNATURE_CONTAINER_HEIGHT);
    const [canvasStyles, setCanvasStyles] = useState<CSSProperties>({});

    useEffect(() => {
        updateCanvasWidth();
    }, [false]);

    useEffect(() => {
        setRealCanvasWidth(props.canvasWidth);
        updateCanvasWidth();
    }, [props.canvasWidth]);

    const updateCanvasWidth = () => {
        let signatureCanvasContext = canvasRef.current.getContext('2d') as CanvasRenderingContext2D;
        setSignatureCanvasContext(signatureCanvasContext);
        if (props.isHighDPI) {
            initCanvasDeviceRatio(signatureCanvasContext);
        } else {
            initCanvasStyles();
        }
        fillCanvasBackground(signatureCanvasContext);

        props.getSignatureCanvasContext(signatureCanvasContext, canvasRef.current);
    }

    const initCanvasStyles = () => {
        setCanvasStyles({width: props.canvasWidth + 'px', height: canvasRef.current?.height + 'px'})
    }

    const initCanvasDeviceRatio = (signatureCanvasContext: CanvasRenderingContext2D) => {
        const canvas = canvasRef.current;
        const oldCanvasWidth = props.canvasWidth;
        const oldCanvasHeight = canvas.height;
        setRealCanvasWidth(oldCanvasWidth * getCanvasDeviceRatio(signatureCanvasContext));
        setCanvasHeight(oldCanvasHeight * getCanvasDeviceRatio(signatureCanvasContext));
        setCanvasStyles({width: oldCanvasWidth + 'px', height: oldCanvasHeight + 'px'});
    }

    const fillCanvasBackground = (signatureCanvasContext: CanvasRenderingContext2D) => {
        signatureCanvasContext.save();

        signatureCanvasContext.fillStyle = 'white';

        signatureCanvasContext.fillRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }

    const {getSignatureCanvasContext, isHighDPI, canvasWidth, ...canvasProps} = props

    return <canvas {...canvasProps} style={canvasStyles} ref={canvasRef} width={realCanvasWidth} height={canvasHeight}
                   className={'canvas-signature ' + (props.className || '')}/>
}